/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import type { Props } from '@atlassian/jira-favourite-button-stateless/src/model/types.tsx';
import FavoriteButtonStateless from '@atlassian/jira-favourite-button-stateless/src/view/view.tsx';

export function FavoriteCellView(props: Props): JSX.Element {
	return (
		<Box xcss={rootStyles}>
			<FavoriteButtonStateless {...props} />
		</Box>
	);
}

FavoriteCellView.defaultProps = {
	isFavorite: undefined,
};

const rootStyles = xcss({
	display: 'flex',
	justifyContent: 'center',
	paddingInlineStart: 'space.050',
	paddingInlineEnd: 'space.050',
	paddingBlockStart: 'space.100',
	paddingBlockEnd: 'space.100',
	alignItems: 'center',
	height: '40px',
	width: '32px',
});
